import { z } from "zod";

export const idParamSchema = z.object({ id: z.coerce.number().int().positive() });
export const uuidParamSchema = z.object({ id: z.uuid() });
export const slugParamSchema = z.object({ slug: z.string().min(1).max(120) });

export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

export const paginatedSchema = <T extends z.ZodType>(item: T) =>
  z.object({
    items: z.array(item),
    page: z.number().int(),
    pageSize: z.number().int(),
    total: z.number().int(),
  });

export interface Paginated<T> {
  items: T[];
  page: number;
  pageSize: number;
  total: number;
}

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiError = z.infer<typeof apiErrorSchema>;

/** Query-string boolean: accepts `true`/`false`/`1`/`0`. */
export const queryBoolean = z
  .enum(["true", "false", "1", "0"])
  .transform((value) => value === "true" || value === "1");

export const isoDateTime = z.iso.datetime({ offset: true });
export const isoDate = z.iso.date();

export const hexColorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, "Expected #RRGGBB");
export const httpsUrlSchema = z.url({ protocol: /^https$/ }).max(2000);
export const httpUrlSchema = z.url({ protocol: /^https?$/ }).max(2000);

export const nullableText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .nullable()
    .transform((value) => (value === "" ? null : value));

export const turnstileTokenSchema = z.string().max(4096).optional();
